jQuery(document).ready(function($) {

  /**
   * Mobile navigation
   */
  $('button.hamburger').click(function() {
    $(this).find('span#nav-icon').toggleClass('open');
    $(this).toggleClass('open');
    $('body').toggleClass('navi-open');

    if ( $('body.navi-open').length > 0 ) {
      $('nav.main-navi').slideDown(300);
      $(this).attr('aria-expanded', 'true');
    } else {
      $('nav.main-navi').hide();
      $(this).attr('aria-expanded', 'false');
    }
  });


  /**
   * Gallery
   */
  var galleryLinks = document.querySelectorAll('.gallery a.gallery-item__image');

  if ( galleryLinks.length > 0 ) {

    var numLinks = galleryLinks.length;
    var currentLink = 0;

    var modal = document.createElement('div');
    modal.classList.add('modal');

    modal.innerHTML = `
      <img class="modal-image" />
      <div class="modal-title"></div>
      <a class="modal-download" href="" download>Lataa kuva</a>
      <div class="modal-counter"></div>
      <div class="modal-prev">&#10094;</div>
      <div class="modal-next">&#10095;</div>
    `;

    document.body.appendChild(modal);

    var modalImage = modal.querySelector('.modal-image');
    var modalTitle = modal.querySelector('.modal-title');
    var modalDownload = modal.querySelector('.modal-download');
    var modalCounter = modal.querySelector('.modal-counter');
    var modalPrev = modal.querySelector('.modal-prev');
    var modalNext = modal.querySelector('.modal-next');

    function showModal(index) {
      var href = galleryLinks[index].getAttribute('href');
      var title = galleryLinks[index].getAttribute('data-caption');
      var counter = (index + 1) + '/' + numLinks;

      modalImage.setAttribute('src', href);
      modalTitle.textContent = title || '';
      modalDownload.setAttribute('href', href);
      modalCounter.textContent = counter;
      modal.style.display = 'block';
    }

    galleryLinks.forEach(function(link, index) {
      link.addEventListener('click', function(event) {
        event.preventDefault();

        currentLink = index;
        showModal(currentLink);
      });
    });

    modal.addEventListener('click', function(event) {
      if ( event.target === modal ) {
        modal.style.display = 'none';
      }
    });

    modalPrev.addEventListener('click', function() {
      currentLink--;

      if ( currentLink < 0 ) {
        currentLink = numLinks - 1;
      }

      showModal(currentLink);
    });

    modalNext.addEventListener('click', function() {
      currentLink++;

      if ( currentLink >= numLinks ) {
        currentLink = 0;
      }

      showModal(currentLink);
    });

    document.addEventListener('keydown', function(event) {

      if ( modal.style.display !== 'block' ) {
        return;
      }

      if ( event.key === 'ArrowLeft' ) {

        currentLink--;

        if ( currentLink < 0 ) {
          currentLink = numLinks - 1;
        }

        showModal(currentLink);

      } else if ( event.key === 'ArrowRight' ) {

        currentLink++;

        if ( currentLink >= numLinks ) {
          currentLink = 0;
        }

        showModal(currentLink);

      } else if ( event.key === 'Escape' ) {

        modal.style.display = 'none';

      }

    });


    /**
     * Pop-up functionality
     */
    var popUpSection = document.querySelector('section.pop-up');

    if ( popUpSection ) {

      var popUpItems = document.querySelectorAll('.pop-up-item');

      popUpItems.forEach(function(item) {

        item.addEventListener('click', function(e) {
          e.preventDefault();

          var popupContent = item.querySelector('.pop-up-content').cloneNode(true);
          var popupBg = document.createElement('div');

          popupBg.classList.add('popup-bg');

          document.body.appendChild(popupBg);
          document.body.appendChild(popupContent);

          var closeBtn = document.createElement('a');

          closeBtn.setAttribute('href', '#');
          closeBtn.classList.add('close');
          closeBtn.textContent = 'Sulje';

          popupContent.appendChild(closeBtn);

          popupContent.style.top = (window.scrollY + window.innerHeight * 0.1) + 'px';
          popupBg.style.display = 'block';
          popupContent.style.display = 'block';

          popupBg.addEventListener('click', closePopup);
          closeBtn.addEventListener('click', closePopup);
        });

      });

      function closePopup(e) {
        e.preventDefault();

        var popupBg = document.querySelector('.popup-bg');
        var popupContent = document.querySelector('body > .pop-up-content');

        if ( popupBg ) {
          popupBg.remove();
        }

        if ( popupContent ) {
          popupContent.remove();
        }
      }

    }

  }


  /**
   * Sticky header
   */
  var win = window;
  var body = document.body;
  var ticking = false;
  var stickyOffset = 114;

  function updateStickyHeader() {
    var scrollTop = win.pageYOffset || document.documentElement.scrollTop;
    var isSticky = scrollTop > stickyOffset;

    if ( isSticky !== body.classList.contains('sticky-header') ) {
      body.classList.toggle('sticky-header', isSticky);
    }

    ticking = false;
  }

  win.addEventListener('scroll', function() {

    if ( !ticking ) {
      win.requestAnimationFrame(updateStickyHeader);
      ticking = true;
    }

  }, {
    passive: true
  });

  updateStickyHeader();


  /**
   * Ajankohtaista – load more
   */
  document.querySelectorAll('section.ajankohtaista-kaikki').forEach(function(section) {

    var button = section.querySelector('[data-news-load-more]');

    if ( !button ) {
      return;
    }

    button.addEventListener('click', function() {

      var hiddenItems = section.querySelectorAll('[data-news-item].is-hidden');
      var itemsToShow = Array.from(hiddenItems).slice(0, 3);

      itemsToShow.forEach(function(item) {
        item.classList.remove('is-hidden');

        /*
         * Jos kortti käyttää reveal-animaatiota, käynnistetään animaatio
         * vasta kun kortti tulee näkyviin.
         */
        if ( item.classList.contains('reveal-card') ) {
          item.classList.remove('is-revealed');

          window.requestAnimationFrame(function() {
            window.requestAnimationFrame(function() {
              item.classList.add('is-revealed');
            });
          });
        }
      });

      if ( !section.querySelector('[data-news-item].is-hidden') ) {
        button.textContent = 'That’s all for now';
        button.disabled = true;
      }

    });

  });


  /**
   * Reveal elements when scrolled into view
   */
  if ( 'IntersectionObserver' in window ) {

    document.querySelectorAll('section.reveal').forEach(function(section) {

      var targets = [];
      var newsItems = section.querySelectorAll('.news-item');

      /*
       * Notes / news grid:
       * heading is animated separately and each card as one element.
       */
      if ( newsItems.length ) {

        var sectionHeading = section.querySelector('.wrap > h1, .wrap > h2');

        if ( sectionHeading ) {
          sectionHeading.classList.add('reveal-text');
          targets.push(sectionHeading);
        }

        newsItems.forEach(function(item, index) {
          item.classList.add('reveal-card');
          item.style.transitionDelay = (index % 3) * 140 + 'ms';

          /*
           * Hidden load-more items are not observed initially.
           */
          if ( !item.classList.contains('is-hidden') ) {
            targets.push(item);
          }
        });

      } else {

        section.querySelectorAll(
          '.wrap h1, .wrap h2, .wrap h3, .wrap h4, .wrap h5, .wrap p, .wrap ul'
        ).forEach(function(element, index) {

          element.classList.add('reveal-text');
          element.style.transitionDelay = Math.min(index * 90, 360) + 'ms';

          targets.push(element);

        });

        section.querySelectorAll('.wrap img').forEach(function(image, index) {

          image.classList.add('reveal-image');
          image.style.transitionDelay = (150 + index * 100) + 'ms';

          targets.push(image);

        });

      }

      var revealObserver = new IntersectionObserver(function(entries) {

        entries.forEach(function(entry) {

          if ( !entry.isIntersecting ) {
            return;
          }

          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);

        });

      }, {
        threshold: 0.15
      });

      targets.forEach(function(target) {
        revealObserver.observe(target);
      });

    });

  } else {

    /*
     * Fallback older browsers.
     */
    document.querySelectorAll(
      '.reveal-text, .reveal-image, .reveal-card'
    ).forEach(function(element) {
      element.classList.add('is-revealed');
    });

  }

  /**
   * Smooth scrolling for links pointing to anchors on the current page
   */
  document.querySelectorAll('a[href*="#"]').forEach(function(link) {

    link.addEventListener('click', function(e) {

      var url;

      try {
        url = new URL(link.href);
      } catch (error) {
        return;
      }

      if ( !url.hash ) {
        return;
      }

      var isSamePage =
        url.origin === window.location.origin &&
        url.pathname === window.location.pathname;

      /*
      * Jos linkki vie toiselle sivulle, annetaan selaimen
      * hoitaa normaali siirtyminen etusivulle + ankkuriin.
      */
      if ( !isSamePage ) {
        return;
      }

      var target;

      try {
        target = document.querySelector(url.hash);
      } catch (error) {
        return;
      }

      if ( !target ) {
        return;
      }

      e.preventDefault();

      /*
      * Suljetaan mobiilivalikko ennen scrollausta.
      */
      if ( window.innerWidth <= 1050 ) {
        $('body').removeClass('navi-open');

        $('button.hamburger')
          .removeClass('open')
          .attr('aria-expanded', 'false');

        $('button.hamburger span#nav-icon').removeClass('open');

        $('nav.main-navi').stop(true, true).hide();

        if ( url.hash === '#contact' ) {

          var targetTop = target.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: targetTop + (window.innerHeight * 0.5),
            behavior: 'auto'
          });

        }
        else if ( url.hash === '#notes' ) {

          var targetTop = target.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: targetTop + (window.innerHeight * -0.1),
            behavior: 'auto'
          });

        } else {

          target.scrollIntoView({
            behavior: 'auto',
            block: 'start'
          });

        }

      } else {

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

      }

      history.replaceState(null, '', url.hash);

    });

  });

  /**
   * Main navigation scroll spy
   *
   * Updates the current menu item according to the section currently
   * visible on the front page.
   */
  var mainNav = document.querySelector('#nav');

  if ( mainNav && document.body.classList.contains('home') ) {

    var homeLink = mainNav.querySelector('.menu-item-home > a');
    var menuLinks = mainNav.querySelectorAll('a[href*="#"]');
    var sections = [];

    menuLinks.forEach(function(link) {

      var url;

      try {
        url = new URL(link.href);
      } catch (error) {
        return;
      }

      if (
        !url.hash ||
        url.origin !== window.location.origin ||
        url.pathname !== window.location.pathname
      ) {
        return;
      }

      var section;

      try {
        section = document.querySelector(url.hash);
      } catch (error) {
        return;
      }

      if ( !section ) {
        return;
      }

      sections.push({
        link: link,
        section: section
      });

    });

    function setCurrentMenuItem(activeLink) {

      mainNav.querySelectorAll('li.current-menu-item').forEach(function(item) {
        item.classList.remove('current-menu-item');
      });

      mainNav.querySelectorAll('a[aria-current]').forEach(function(link) {
        link.removeAttribute('aria-current');
      });

      if ( !activeLink ) {
        return;
      }

      var menuItem = activeLink.closest('li');

      if ( menuItem ) {
        menuItem.classList.add('current-menu-item');
      }

      activeLink.setAttribute('aria-current', 'page');

    }

    /*
     * Home is active while the page is above the first anchored section.
     */
    function updateHomeMenuItem() {

      if ( !sections.length || !homeLink ) {
        return;
      }

      var firstSectionTop = sections[0].section.getBoundingClientRect().top;

      if ( firstSectionTop > window.innerHeight * 0.45 ) {
        setCurrentMenuItem(homeLink);
      }

    }

    var menuObserver = new IntersectionObserver(function(entries) {

      entries.forEach(function(entry) {

        if ( !entry.isIntersecting ) {
          return;
        }

        var match = sections.find(function(item) {
          return item.section === entry.target;
        });

        if ( match ) {
          setCurrentMenuItem(match.link);
        }

      });

    }, {
      rootMargin: '-40% 0px -50% 0px',
      threshold: 0
    });

    sections.forEach(function(item) {
      menuObserver.observe(item.section);
    });

    window.addEventListener('scroll', updateHomeMenuItem, {
      passive: true
    });

    updateHomeMenuItem();

  }

  /**
 * Adjust Contact anchor position when arriving from another page.
 * Only on screens <= 1090px.
 */
  if (
    window.innerWidth <= 1050 &&
    window.location.hash === '#contact'
  ) {
    var contactTarget = document.querySelector('#contact');

    if ( contactTarget ) {
      setTimeout(function() {
        var targetTop =
          contactTarget.getBoundingClientRect().top +
          window.pageYOffset +
          (window.innerHeight * 0.5);

        window.scrollTo({
          top: targetTop,
          behavior: 'auto'
        });
      }, 50);
    }
  }
});